import React from 'react';
import classnames from 'classnames';
import { func, bool, string } from 'prop-types';
import Icon from './icon';

const ButtonIcon = ({
  disabled,
  onClick,
  className,
  ...props
}) => (
  <Icon
    role="button"
    aria-disabled={disabled}
    onClick={!disabled ? onClick : undefined}
    className={classnames(
      'button',
      className,
    )}
    inactive={disabled}
    {...props}
  />
);

ButtonIcon.propTypes = {
  onClick: func,
  disabled: bool,
  className: string,
};

ButtonIcon.defaultProps = {
  disabled: false,
  className: null,
  onClick: null,
};

export default ButtonIcon;
